import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import "../../Assets/Css/admin_style.css";
import HomeIcon from "../../Assets/Images/Home.svg";
import WorkIcon from "../../Assets/Images/work_icon.svg";
import BlogIcon from "../../Assets/Images/blog_icon.svg";
import GalleryIcon from "../../Assets/Images/gallery_icon.svg";
import TestimonialIcon from "../../Assets/Images/testimonial_icon.svg";
import EventIcon from "../../Assets/Images/event_icon.svg";
 


const Sidebar = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <ul className="sidebar-menu pe-0">
        <li className={`sidebar-item ${isActive('/admin/bannerList') ? 'active' : ''}`}>
          <Link to="/admin/bannerList" className="sidebar-link">
            <img src={HomeIcon} alt="Icon" className="w-auto pe-3" />
            <span>Home Page Banner</span>
          </Link>
        </li>
        <li className={`sidebar-item ${isActive('/admin/workList') ? 'active' : ''}`}>
          <Link to="/admin/workList" className="sidebar-link">
            {/* <i className="bi bi-person-workspace sidebar-icon"></i> */}
            <img src={WorkIcon } alt=" Icon" className="w-auto pe-3" />
            <span>Our Work</span>
          </Link>
        </li>
        <li className={`sidebar-item ${isActive('/admin/blogList') ? 'active' : ''}`}>
          <Link to="/admin/blogList" className="sidebar-link">
            {/* <i className="bi bi-file-text sidebar-icon"></i> */}
            <img src={ BlogIcon} alt=" Icon" className="w-auto pe-3" />
            <span>Blogs</span>
          </Link>
        </li>
        <li className={`sidebar-item ${isActive('/admin/galleryList') ? 'active' : ''}`}>
          <Link to="/admin/galleryList" className="sidebar-link">
            {/* <i className="bi bi-file-earmark-richtext sidebar-icon"></i> */}
            <img src={ GalleryIcon} alt=" Icon" className="w-auto pe-3" />
            <span>Gallery</span>
          </Link>
        </li>
        <li className={`sidebar-item ${isActive('/admin/eventList') ? 'active' : ''}`}>
          <Link to="/admin/eventList" className="sidebar-link">
            {/* <i className="bi bi-file-earmark-richtext sidebar-icon"></i> */}
            <img src={EventIcon } alt=" Icon" className="w-auto pe-3" />
            <span>Event List</span>
          </Link>
        </li>
        <li className={`sidebar-item ${isActive('/admin/testimonialList') ? 'active' : ''}`}>
          <Link to="/admin/testimonialList" className="sidebar-link">
            {/* <i className="bi bi-file-earmark-richtext sidebar-icon"></i> */}
            <img src={TestimonialIcon } alt=" Icon" className="w-auto pe-3" />
            <span>Testimonials</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
